import React, { useState, useRef } from 'react'
import styled, { useTheme } from 'styled-components'
import useNavbar from './useNavbar'
import ContactUsModal from '../ContactUsModal'
import SupportCall from '../Icons/SupportCall'
import Cart from '../Icons/Cart'
import { hexToRgbA } from '../../utils/helper'
import { Tooltip } from '../Common'
import HeaderAvatar from '../Icons/HeaderAvatar'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'
const Menu = styled.div`
  position: relative;
  display: flex;
  padding: 24px 0;
  justify-content: space-between;
`

const Section = styled.div`
  display: flex;
  gap: 32px;
  justify-content: space-between;
`

const MenuItem = styled.a`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: bold;
  line-height: 1.43;
  color: ${props => props.theme.color.primaryText};
  cursor: pointer;
  text-decoration: none;
  &:hover,
  &.active {
    color: ${props => props.theme.color.brand};
  }
`

const PermanentMenuItem = styled.a`
  cursor: pointer;
  overflow: hidden;
  position: relative;

  div {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  svg {
    cursor: pointer;
    opacity: 0.5;
    border-radius: 24px;
    padding: 8px;
    border: 1px solid transparent;
  }

  &.active {
    svg {
      opacity: 1;
      background-color: ${props =>
        hexToRgbA(props.theme.color.primaryText, 0.05)};
    }
  }
  &:hover {
    svg {
      background-color: ${props =>
        hexToRgbA(props.theme.color.primaryText, 0.03)};
      opacity: 1;
      border: 1px solid ${props => props.theme.color.borderLight};
    }
  }
`

const Dweb = ({ items }) => {
  const theme = useTheme()
  const history = useHistory()
  const navbarSettings = useSelector(
    store => store.centerreducer?.regionsDetails?.client?.navbar_settings
  )

  const isProductsEnabled = navbarSettings?.find(
    item => item.slug === 'products'
  )

  const {
    selectedItemIndex,
    isLoggedIn,
    commonMenuItems,
    loginMenuItem
  } = useNavbar(items)

  const [isContactModalOpen, setContactModalOpen] = useState(false)
  const contactButtonRef = useRef(null)
  const cartButtonRef = useRef(null)
  const profileButtonRef = useRef(null)

  const renderOption = ({ index, children, slug, url }) => {
    return (
      <MenuItem
        key={slug}
        href={url}
        className={index === selectedItemIndex ? 'active' : ''}
      >
        {children}
      </MenuItem>
    )
  }

  return (
    <>
      <Menu>
        <Section>
          {commonMenuItems.map(({ index, title, slug, url }) =>
            renderOption({
              index,
              children: <>{title}</>,
              slug,
              url
            })
          )}
        </Section>
        <Section style={{ gap: '6px' }}>
          <Tooltip text="Contact us" triggerRef={contactButtonRef}>
            <PermanentMenuItem
              ref={contactButtonRef}
              className={isContactModalOpen ? 'active' : ''}
              onClick={() => setContactModalOpen(true)}
            >
              <div>
                <SupportCall
                  fill={
                    isContactModalOpen
                      ? theme.color.brand
                      : theme.color.primaryText
                  }
                />
              </div>
            </PermanentMenuItem>
          </Tooltip>
          {isProductsEnabled && (
            <Tooltip text="Cart" triggerRef={cartButtonRef}>
              <PermanentMenuItem
                ref={cartButtonRef}
                className={
                  window.location.pathname.includes('/cart') ? 'active' : ''
                }
                href="/cart"
              >
                <div>
                  <Cart
                    fill={
                      window.location.pathname.includes('/cart')
                        ? theme.color.brand
                        : theme.color.primaryText
                    }
                  />
                </div>
              </PermanentMenuItem>
            </Tooltip>
          )}
          {isLoggedIn ? (
            <Tooltip text="My account" triggerRef={profileButtonRef}>
              <PermanentMenuItem
                ref={profileButtonRef}
                className={
                  window.location.pathname.includes('/my-account')
                    ? 'active'
                    : ''
                }
                onClick={() => {
                  history.push(loginMenuItem.url)
                }}
              >
                <div>
                  <HeaderAvatar
                    fill={
                      window.location.pathname.includes('/my-account')
                        ? theme.color.brand
                        : theme.color.primaryText
                    }
                  />
                </div>
              </PermanentMenuItem>
            </Tooltip>
          ) : (
            renderOption({
              index: loginMenuItem?.index,
              children: <>{loginMenuItem?.title}</>,
              slug: loginMenuItem?.slug,
              url: loginMenuItem?.url || '/my-account'
            })
          )}
        </Section>
      </Menu>
      <ContactUsModal
        isOpen={isContactModalOpen}
        onClose={() => setContactModalOpen(false)}
        triggerRef={contactButtonRef}
      />
    </>
  )
}

export default Dweb
